<template>
    <div class="bg-base-200 h-screen-header rounded-xl">
        <div class="flex">
            <!-- 歌词 -->
            <div class="w-96 flex flex-col !hidden md:!block" v-if="showControl && tracks.length > 0">
                <div class="mt-2 ml-2 text-md">播放：</div>
                <div class="bg-base-100 rounded-xl mr-2 flex flex-col">
                    <div v-for="(item, index) in tracks.slice(queueIndex, queueIndex + 1)" :key="'q' + index"
                        class="flex justify-between items-center">
                        <div class="flex items-center mt-1">
                            <router-link :to="{ name: 'playingList', params: { id: item.id } }"
                                class="mx-2 h-16 w-16 my-1 hover:brightness-50">
                                <img v-if="item.image" :src="item.image" class="rounded-md"
                                    style="width: 56px; height: 56px; object-fit: cover;">
                                <img v-else src="/static/dist/img/album_null.jpg"
                                    style="width: 56px; height: 56px; object-fit: cover;">
                            </router-link>
                            <div class="min-w-0 flex-1">
                                <router-link :to="{ name: 'album', params: { id: item.albumId } }"
                                    class="hover:underline">
                                    <div class="truncate">
                                        {{ item.title }}
                                    </div>
                                </router-link>
                                <router-link :to="{ name: 'artist', params: { id: item.artistId } }"
                                    class="hover:underline">
                                    <div class="w-64 truncate text-gray-400 text-xs">
                                        {{ item.artist || item.album }}
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div>
                            <div class="flex items-center justify-center">
                                <button variant="link" class="m-2" @click="next">
                                    <svg t="1697292423300" class="icon fill-current hover:fill-gray-600"
                                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        p-id="2433" width="32" height="32">
                                        <path
                                            d="M213.333333 331.349333c0-66.304 72.362667-107.306667 129.237334-73.173333l301.056 180.650667c55.253333 33.152 55.253333 113.194667 0 146.346666L342.613333 765.824c-56.874667 34.133333-129.237333-6.826667-129.237333-73.173333V331.349333zM599.722667 512L298.666667 331.349333v361.301334L599.722667 512zM768 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                            p-id="2434"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center mt-4 rounded-xl flex-1 flex-col">
                    <div class="relative overflow-hidden w-full h-full rounded-xl mr-2">
                        <!-- 背景图片和模糊效果 -->
                        <!--                        <div class="absolute inset-0 bg-cover bg-center blur-sm rounded-xl opacity-5" :style="{ 'background-image': 'linear-gradient(to bottom, transparent, black),' + backgroundImage }"></div>-->

                        <!-- 歌词容器 -->
                        <div class="p-4 text-white">
                            <div class="overflow-y-auto h-screen-lyric">
                                <div>
                                    <ul ref="lyricUL">
                                        <li v-for="(item, i) in lyricsObjArr"
                                            :class="[lyricIndex === i ? 'text-2xl text-purple-600' : 'text-base text-gray-400', 'text-center', 'mb-2', 'cursor-pointer']"
                                            :key="item.uid" :data-index="i" ref="lyric" @click="scrollToLyric(i)">
                                            <div>{{ item.lyric }}</div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 正在播放 -->
            <div class="bg-base-100 rounded-3xl shadow-xl p-3 h-screen-header flex-1 overflow-x-auto">
                <!-- 按钮组 -->
                <div class="flex flex-col">
                    <h1 class="mt-2 ml-2 text-2xl flex items-center">
                        <svg t="1734154913013" v-if="showControl"
                            class="icon h-5 w-5 fill-neutral-content cursor-pointer" @click="showControl = !showControl"
                            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1622"
                            width="200" height="200">
                            <path
                                d="M782 99m41.5 0l0 0q41.5 0 41.5 41.5l0 747q0 41.5-41.5 41.5l0 0q-41.5 0-41.5-41.5l0-747q0-41.5 41.5-41.5Z"
                                p-id="1623"></path>
                            <path
                                d="M603.5 858.83L244.89 514 603.5 169.17a40.31 40.31 0 0 0 12.5-29c0-36.58-46-54.9-72.88-29L184.51 455.94c-33.35 32.07-33.35 84.05 0 116.12l358.61 344.83c26.89 25.87 72.88 7.55 72.88-29a40.31 40.31 0 0 0-12.5-29.06z">
                            </path>
                        </svg>
                        <svg t="1734155012178" v-else class="icon h-5 w-5 fill-neutral-content cursor-pointer"
                            viewBox="0 0 1024 1024" @click="showControl = !showControl" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="1775" width="200" height="200">
                            <path
                                d="M245.71 927m-41.47 0l0 0q-41.47 0-41.47-41.47l0-747.06q0-41.47 41.47-41.47l0 0q41.47 0 41.47 41.47l0 747.06q0 41.47-41.47 41.47Z"
                                p-id="1776"></path>
                            <path
                                d="M424.09 856.83L782.44 512 424.09 167.17a40.31 40.31 0 0 1-12.5-29c0-36.58 46-54.9 72.83-29l358.36 344.77c33.32 32.07 33.32 84.05 0 116.12L484.42 914.89c-26.87 25.87-72.83 7.55-72.83-29a40.31 40.31 0 0 1 12.5-29.06z">
                            </path>
                        </svg>
                        小爱播放
                    </h1>
                    <div class="mt-2 ml-2">
                        <button class="btn btn-sm mr-2 tooltip" @click="shuffle" data-tip="打乱顺序">
                            <svg t="1734160766139" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1470" width="200" height="200">
                                <path
                                    d="M753.564731 337.471035c-45.8697 0-160.259984 113.849978-243.789399 194.548928C383.134027 654.383848 263.508509 773.284865 167.764911 773.284865l-58.892295 0c-24.068162 0-43.581588-19.526729-43.581588-43.581588s19.513426-43.581588 43.581588-43.581588l58.892295 0c60.504002 0 183.002964-121.68134 281.432741-216.784348 119.79641-115.744117 223.254713-219.029482 304.368102-219.029482l56.209186 0-59.641355-57.828057c-17.033955-16.993023-17.060561-42.902112-0.057305-59.927881 17.002232-17.030885 44.596707-17.064654 61.631686-0.065492l134.207631 133.874033c8.192589 8.172123 12.794397 19.238157 12.794397 30.803563 0 11.564383-4.601808 22.604834-12.794397 30.776957L811.706943 461.72599c-8.505721 8.486278-19.646456 12.522198-30.78719 12.522198-11.166317 0-22.333658-4.676509-30.844495-13.199627-17.003256-17.025769-16.975627-45.432749 0.057305-62.425771l59.641355-61.151755L753.564731 337.471035zM811.706943 561.66105c-17.034978-16.999163-44.629453-16.972557-61.631686 0.058328-17.003256 17.024745-16.975627 46.257533 0.057305 63.250556l59.641355 61.150732-56.209186 0c-35.793204 0-95.590102-52.946886-154.87637-108.373243-17.576307-16.435321-45.161572-16.3422-61.594847 1.226944-16.444531 17.568121-15.523555 46.393633 2.053776 62.823837 90.322122 84.458577 151.246703 131.484613 214.417441 131.484613l56.209186 0-59.641355 57.824987c-17.033955 16.993023-17.060561 43.736107-0.057305 60.761875 8.511861 8.523117 19.678178 12.369725 30.844495 12.369725 11.140735 0 22.281469-4.453429 30.78719-12.939707L945.914574 757.311055c8.192589-8.173147 12.794397-19.315928 12.794397-30.881334 0-11.564383-4.601808-22.682605-12.794397-30.855752L811.706943 561.66105zM108.871593 337.471035l58.892295 0c45.932122 0 114.40154 58.455343 168.915108 107.942431 8.352225 7.576559 18.832927 12.140505 29.29214 12.140505 11.852956 0 23.673166-4.394077 32.270984-13.857613 16.182564-17.807574 14.859429-46.823422-2.958378-62.998823-85.247546-77.381391-156.561755-130.388652-227.519854-130.388652l-58.892295 0c-24.068162 0-43.581588 19.526729-43.581588 43.581588S84.804455 337.471035 108.871593 337.471035z"
                                    p-id="1471"></path>
                            </svg>
                        </button>
                        <button class="btn btn-sm mr-2 tooltip" @click="random()" data-tip="随机播放">
                            <svg t="1734160963084" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7677" width="200" height="200">
                                <path
                                    d="M512 176c158.784 0 288 123.136 288 274.56v90.24h38.4a57.6 57.6 0 0 1 57.6 57.6v192a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6V450.56c0-119.68-103.36-216.96-230.4-216.96S281.6 330.88 281.6 450.56v339.84a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6v-192a57.6 57.6 0 0 1 57.6-57.6h38.4V450.56c0-151.424 129.216-274.56 288-274.56z m-32.128 309.632a28.928 28.928 0 0 1 27.072 17.664l47.296 112.96 8.512-18.112a28.8 28.8 0 0 1 26.048-16.512h76.8a28.8 28.8 0 1 1 0 57.6h-58.496l-28.416 60.224a28.8 28.8 0 0 1-26.048 16.576h-0.64a28.8 28.8 0 0 1-25.92-17.728l-44.288-105.92-10.624 28.16a28.8 28.8 0 0 1-26.944 18.624H358.4a28.8 28.8 0 1 1 0-57.6h65.92l29.12-77.312a28.8 28.8 0 0 1 26.432-18.688z">
                                </path>
                            </svg>
                        </button>
                        <button class="btn btn-sm tooltip" @click="clear" data-tip="清空队列">
                            <svg t="1734161038628" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8667" width="200" height="200">
                                <path
                                    d="M228 385v488.782c0 29.34 24.03 53.218 53.784 53.218h460.432C771.97 927 796 903.123 796 873.782V385H228z m640 0v488.782C868 942.99 811.634 999 742.216 999H281.784C212.366 999 156 942.99 156 873.782V385H87c-19.882 0-36-16.118-36-36v-33.575c0-38.642 14.962-78.077 41.31-108.02C121.451 174.289 162.222 155 208.593 155h607.143c46.387 0 87.094 19.174 116.128 52.197C958.151 237.096 973 276.53 973 315.425V349c0 19.882-16.118 36-36 36h-69zM352 118.5c-19.882 0-36-16.118-36-36s16.118-36 36-36h320c19.882 0 36 16.118 36 36s-16.118 36-36 36H352z m525.791 136.238C862.17 236.97 841.003 227 815.736 227H208.593c-25.208 0-46.47 10.06-62.23 27.969-14.246 16.19-22.7 37.655-23.326 58.031h777.927c-0.612-20.673-9.003-42.145-23.173-58.262zM336.5 528c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z m140 0c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z m140 0c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z">
                                </path>
                            </svg>
                        </button>
                        <button variant="link" class="btn btn-sm tooltip ml-4 mr-2" @click="previous" data-tip="上一首">
                            <svg t="1697292326917" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4372" width="32" height="32">
                                <path
                                    d="M810.666667 331.349333c0-66.304-72.362667-107.306667-129.237334-73.173333l-301.056 180.650667c-55.253333 33.152-55.253333 113.194667 0 146.346666l301.056 180.650667c56.874667 34.133333 129.237333-6.826667 129.237334-73.173333V331.349333zM424.277333 512L725.333333 331.349333v361.301334L424.277333 512zM256 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                    p-id="4373"></path>
                            </svg>
                        </button>
                        <button class="btn btn-sm tooltip mr-2" data-tip="播放" @click="playPause">
                            <svg v-if="!isPlaying" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9809" width="200" height="200">
                                <path
                                    d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 768C317.92 864 160 706.08 160 512S317.92 160 512 160s352 157.92 352 352-157.92 352-352 352z"
                                    p-id="9810"></path>
                                <path
                                    d="M466.816 324.96a32 32 0 0 0-50.816 25.888v339.776a32 32 0 0 0 50.816 25.856l233.6-169.888a32 32 0 0 0 0-51.776l-233.6-169.856z"
                                    p-id="9811"></path>
                            </svg>
                            <svg v-else class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="4492" width="32" height="32">
                                <path
                                    d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM320 320v384h128V320H320z m256 0v384h128V320H576z"
                                    p-id="4493"></path>
                            </svg>
                        </button>
                        <button variant="link" class="btn btn-sm tooltip" @click="next" data-tip="下一首">
                            <svg t="1697292423300" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2433" width="32" height="32">
                                <path
                                    d="M213.333333 331.349333c0-66.304 72.362667-107.306667 129.237334-73.173333l301.056 180.650667c55.253333 33.152 55.253333 113.194667 0 146.346666L342.613333 765.824c-56.874667 34.133333-129.237333-6.826667-129.237333-73.173333V331.349333zM599.722667 512L298.666667 331.349333v361.301334L599.722667 512zM768 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                    p-id="2434"></path>
                            </svg>
                        </button>
                    </div>
                </div>
                <!-- 播放列表 -->
                <div class="rounded-xl overflow-y-auto h-[86.3%]" v-if="tracks.length > 0">
                    <div class="rounded-xl overflow-x-auto">
                        <table class="table" ref="trackTable">
                            <!-- head -->
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>标题</th>
                                    <th class="!hidden md:!table-cell">专辑</th>
                                    <th class="!hidden md:!table-cell">时长</th>
                                    <th class="!hidden md:!table-cell">大小</th>
                                    <th class="!hidden md:!table-cell">比特率</th>
                                    <th class="!hidden md:!table-cell">播放</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in tracks" :key="index" :draggable="true"
                                    @dragstart="dragStart($event, index)" @dragover.prevent @dragenter.prevent
                                    @drop="drop($event, index)" @dragend="dragEnd($event)"
                                    :class="['hover:bg-base-300', item.status === 'playing' ? 'bg-base-300 text-purple-600' : '']">
                                    <td @click="play(item.index)" class="cursor-move">
                                        <div v-if="item.status === 'playing'">
                                            <span class="loading loading-bars loading-xs"></span>
                                        </div>
                                        <div v-else>
                                            <div>
                                                {{ item.index }}
                                            </div>
                                        </div>
                                    </td>
                                    <td @click="play(item.index)" class="max-w-[250px] min-w-[200px]">
                                        <div class="flex items-center gap-3">
                                            <div class="avatar">
                                                <div class="mask mask-squircle w-12 h-12 tile-img">
                                                    <img :src="item.image" v-if="item.image" alt="" />
                                                    <img v-else src="/static/dist/img/album_null.jpg">
                                                </div>
                                            </div>
                                            <div>
                                                <div class="font-bold truncate w-[180px]">
                                                    {{ item.title }}
                                                    <div class="badge ml-1" v-if="item.fromFolder === 'webdav'">
                                                        <svg t="1705398013860" class="icon fill-current w-4 h-4"
                                                            viewBox="0 0 1024 1024" version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg" p-id="2454" width="200"
                                                            height="200">
                                                            <path
                                                                d="M533.333333 256a212.416 212.416 0 0 1 212.864 205.333333l0.277334 7.488a52.970667 52.970667 0 0 0 35.413333 48.064l3.136 1.088a131.584 131.584 0 0 1 89.024 109.418667A128.128 128.128 0 0 1 746.666667 768H303.552a152.554667 152.554667 0 0 1-153.301333-132.629333 148.821333 148.821333 0 0 1 123.306666-163.690667l7.296-1.237333a53.034667 53.034667 0 0 0 42.88-40.682667l1.6-7.210667A214.570667 214.570667 0 0 1 533.333333 256m0-64a277.333333 277.333333 0 0 0-270.442666 216.554667A213.226667 213.226667 0 0 0 298.666667 832h448a192 192 0 0 0 63.488-373.034667A277.12 277.12 0 0 0 533.333333 192z"
                                                                p-id="2455"></path>
                                                            <path
                                                                d="M405.333333 618.666667m32 0l192 0q32 0 32 32l0 0q0 32-32 32l-192 0q-32 0-32-32l0 0q0-32 32-32Z"
                                                                fill="#FF9C00" p-id="2456"></path>
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div class="text-sm opacity-50 truncate">{{ item.artist }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td @click="play(item.index)" class="!hidden md:!table-cell">{{
                                        item.album }}</td>
                                    <td @click="play(item.index)" class="!hidden md:!table-cell">{{
                                        formatDuration(item.duration) }}</td>
                                    <td @click="play(item.index)" class="!hidden md:!table-cell">{{
                                        formatSize(item.size) }}
                                    </td>
                                    <td @click="play(item.index)" class="!hidden md:!table-cell">{{ item.bitrate }}kps
                                    </td>
                                    <td @click="play(item.index)" class="!hidden md:!table-cell">{{ item.playsCount }}
                                    </td>
                                    <td class="!hidden md:!table-cell">
                                        <!-- <track-action :item="item" :index="index"></track-action> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else>
                    <div class="flex justify-center mt-24">
                        <div class="flex flex-col items-center text-gray-500">
                            <img src="/static/dist/img/play_music.svg" alt="Album" class=" h-64 z-1 mb-4" />
                            <div>暂无播放</div>
                            <div>
                                <router-link :to="{ 'path': '/albums/' + 'recently-added' }"
                                    class="underline underline-offset-2">
                                    去聆听音乐吧!
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TrackAction from "@/views/library/track/TrackAction";
import { normalizeMiTrack } from '@/api/apiUrl/subsonic/serializers'
export default {
    components: {
        TrackAction
    },
    data() {
        return {
            showControl: true,
            lyricIndex: 0,
            lyricsObjArr: [],
            tracks: [],
            currentTime: 0,
            timer: null,
            refreshTimer: null
        }
    },
    computed: {
        isPlaying() {
            const playingTrack = this.tracks.find(track => track.status === 'playing')
            return playingTrack ? true : false
        },
        queueIndex() {
            return this.tracks.find(track => track.status === 'playing')?.index || 0
        },
        songImageWall() {
            if (this.tracks[this.queueIndex].image) {
                return this.tracks[this.queueIndex].image.replace('al-', 'alw-')
            } else {
                return this.tracks[this.queueIndex].image
            }
        },
        backgroundImage() {
            return `url('${this.tracks[this.queueIndex].image || '/static/dist/img/album_null.jpg'}')`
        },
        remainingTime() {
            const playingTrack = this.tracks.find(track => track.status === 'playing')
            if (!playingTrack) return 0
            return playingTrack.duration - this.currentTime
        }
    },
    created() {
        this.fetchPlaying()
        this.startTimer()
        this.startRefreshTimer()
    },
    beforeDestroy() {
        this.stopTimer()
        this.stopRefreshTimer()
    },
    watch: {
        currentTime: {
            handler() {
                // 匹配歌词
                for (let i = 0; i < this.lyricsObjArr.length; i++) {
                    if (this.currentTime > (parseInt(this.lyricsObjArr[i].time))) {
                        const index = this.$refs.lyric[i].dataset.index
                        if (i === parseInt(index)) {
                            this.lyricIndex = i
                            this.$refs.lyricUL.style.transform = `translateY(${170 - (30 * (i + 1))}px)`
                            this.$refs.lyricUL.style.transform = '.transition = \'all 1s\''
                        }
                    }
                }
                
                // 检查是否需要刷新播放状态
                if (this.remainingTime <= 0) {
                    this.fetchPlaying()
                }
            }
        },
    },
    methods: {
        startTimer() {
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                if (this.isPlaying) {
                    this.currentTime += 1
                }
            }, 1000)
        },
        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        startRefreshTimer() {
            if (this.refreshTimer) {
                clearInterval(this.refreshTimer)
            }
            // 每30秒刷新一次播放状态
            this.refreshTimer = setInterval(() => {
                this.fetchPlaying()
            }, 30000)
        },
        stopRefreshTimer() {
            if (this.refreshTimer) {
                clearInterval(this.refreshTimer)
                this.refreshTimer = null
            }
        },
        fetchPlaying() {
            this.$api.Task.miServicePlaying().then((res) => {
                this.tracks = res.data.map(normalizeMiTrack)
                const playingTrack = this.tracks.find(track => track.status === 'playing')
                this.lyricsObjArr = this.formatLyrics(playingTrack?.lyrics || '')
                this.currentTime = playingTrack?.current_time || 0
            })
        },
        play(index) {
            if (index === this.queueIndex) {
                return 
            }
            this.$api.Task.miServicePlayQueue({ index }).then((res) => {
                this.$myMsg.notify({
                    title: '播放成功！',
                    type: 'success',
                    time: 2000,
                });
                this.fetchPlaying()
            })
        },
        playPause() {
            const playingTrack = this.tracks.find(track => track.status === 'playing')
            if (playingTrack) {
                this.$api.Task.miServicePause().then(() => {
                    this.$myMsg.notify({
                        title: '暂停播放！',
                        type: 'success', 
                        time: 2000,
                    });
                    this.fetchPlaying()
                    if (this.isPlaying) {
                        this.stopTimer()
                    } else {
                        this.startTimer()
                    }
                })
            }
        },
        dragstart(id, event) {
            event.dataTransfer.setData('application/x-track-id', id)
        },
        remove(idx) {
            return this.$store.commit('removeFromQueue', idx)
        },
        clear() {
            return this.$store.commit('clearQueue')
        },
        shuffle() {
            return this.$store.commit('shuffleQueue')
        },
        formatDuration(value) {
            if (!isFinite(value)) {
                return '∞'
            }
            const minutes = Math.floor(value / 60)
            const seconds = Math.floor(value % 60)
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        },
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        random() {
            this.$api.Task.miServiceRandom().then((res) => {
                this.$myMsg.notify({
                    title: '随机播放成功！',
                    type: 'success',
                    time: 2000,
                });
                this.fetchPlaying()
            })
        },
        formatLyrics(lyrics) {
            if (!lyrics) return []
            const regNewLine = /\n/
            const lineArr = lyrics.split(regNewLine) // 每行歌词的数组

            const lyricsObjArr = []
            lineArr.forEach(item => {
                if (item === '') return
                const spiltList = item.split(']')
                const spiltListLength = spiltList.length
                const content = spiltList[spiltListLength - 1].trim()

                const timeArray = spiltList.slice(0, spiltListLength - 1)
                timeArray.forEach(dt => {
                    const obj = {}
                    obj.lyric = content === '' ? '' : content
                    obj.time = this.formatLyricTime(dt.slice(1))
                    obj.uid = Math.random().toString().slice(-6)
                    if (obj.lyric === '') {
                        console.log('')
                    } else {
                        lyricsObjArr.push(obj)
                    }
                })
            })
            return lyricsObjArr.sort((a, b) => a.time - b.time)
        },
        formatLyricTime(item) { // 格式化歌词的时间 转换成 sss:ms
            if (item.indexOf('.') === -1) {
                const timeParts = item.split(':')
                const hours = parseInt(timeParts[0])
                const minutes = parseInt(timeParts[1])
                const seconds = parseInt(timeParts[2])
                const totalTime = hours * 60 * 60 + minutes * 60 + seconds
                return Number(totalTime)
            } else {
                const regTime = /\d{2}:\d{2}.\d{2,3}/
                const isTime = item.match(regTime)
                const time = isTime ? isTime[0] : '00:00.00'
                const regMin = /.*:/
                const regSec = /:.*\./
                const regMs = /\./

                const min = parseInt(time.match(regMin)[0].slice(0, 2))
                let sec = parseInt(time.match(regSec)[0].slice(1, 3))
                const ms = time.slice(time.match(regMs).index + 1, time.match(regMs).index + 3)
                if (min !== 0) {
                    sec += min * 60
                }
                return Number(sec + '.' + ms)
            }
        },
        scrollToLyric(i) {
            const currentTime = this.lyricsObjArr[i].time
            const seek = currentTime / this.duration
            this.$store.dispatch('seek', seek)
        },
        next() {
            let index = 1;
            for (let i = 0; i < this.tracks.length; i++) {
                if (this.tracks[i].status === 'playing' && i < this.tracks.length - 1) {
                    index = this.tracks[i + 1].index;
                    break;
                }
            }
            this.$api.Task.miServicePlayQueue({ index }).then((res) => {
                this.$myMsg.notify({
                    title: '播放成功！',
                    type: 'success',
                    time: 2000,
                });
                this.fetchPlaying()
            })
        },
        previous() {
            let index = 1;
            for (let i = 0; i < this.tracks.length; i++) {
                if (this.tracks[i].status === 'playing' && i > 0) {
                    index = this.tracks[i - 1].index;
                    break;
                }
            }
            this.$api.Task.miServicePlayQueue({ index }).then((res) => {
                this.$myMsg.notify({
                    title: '播放成功！',
                    type: 'success',
                    time: 2000,
                });
                this.fetchPlaying()
            })
        },
        formatDuration(value) {
            if (!isFinite(value)) {
                return '∞'
            }
            const minutes = Math.floor(value / 60)
            const seconds = Math.floor(value % 60)
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        },
        formatSize(value) {
            return (value / 1024 / 1024).toFixed(1) + ' MB'
        },
        clear() {
            this.$api.Task.miServiceStopQueue().then((res) => {
                console.log(res)
                if (res.result) {
                    this.$myMsg.notify({
                        title: '停止成功！',
                        type: 'success',
                        time: 2000,
                    });
                    this.fetchPlaying()
                }
            })
        },
        dragStart(event, index) {
                this.draggedIndex = index;
                event.dataTransfer.effectAllowed = 'move';
                event.target.style.opacity = '0.4';
            },
        dragEnd(event) {
            const rows = event.target.parentElement.getElementsByTagName('tr');
            for (let row of rows) {
                row.style.opacity = '1';
            }
        },
        drop(event, index) {
            event.preventDefault();
            const draggedItem = this.tracks[this.draggedIndex];
            const newItem = this.tracks[index];
            this.tracks.splice(this.draggedIndex, 1);
            this.tracks.splice(index, 0, draggedItem);
            this.updatePlaylistOrder(draggedItem.index, newItem.index);
            this.draggedIndex = null;
        },
        updatePlaylistOrder(oldIndex, newIndex) {
            console.log(oldIndex, newIndex)
            this.$api.Task.miServiceUpdatePlaylistOrder({ old_index: oldIndex, index: newIndex }).then((res) => {
                this.$myMsg.notify({
                    title: '更新成功！',
                    type: 'success',
                    time: 2000,
                });
            })
        },
        shuffle() {
            this.$api.Task.miServiceShuffle().then((res) => {
                this.$myMsg.notify({
                    title: '打乱成功！',
                    type: 'success',
                    time: 2000,
                });
                this.fetchPlaying()
            })
        }
    }
}
</script>
<style>
.h-screen-lyric {
    height: calc(100vh - 230px);
}
</style>
